const en = {
  translation: {},
};

export default en;
